import DetailVMinventory from "../views/vms/onExchange/inventory/DetailVMinventory.vue";
const token = sessionStorage.getItem("token");
const role = sessionStorage.getItem("role");
const isAuth = (to, from, next) => {
    // role == 2 || role == 1 || role == 13 || role == 15
    if (token) {
        if (role == 1 || role == 2 || role == 6 || role == 4) {
            next();
        } else {
            next("/");
        }
    } else {
        next("/login");
    }
};

export default {
    path: "/on-exchange",
    name: "OnExchange",
    component: () => import("../views/vms/onExchange/Layout.vue"),
    beforeEnter: isAuth,
    meta: {
        breadcrumb: "On Exchange",
    },
    children: [
        {
            path: "deposit",
            component: () => import("../views/vms/onExchange/deposit/LayoutDeposit.vue"),
            meta: {
                breadcrumb: "Deposit",
            },
            children: [
                {
                    path: "",
                    name: "Deposit",
                    component: () => import("../views/vms/onExchange/deposit/Deposite.vue"),
                    meta: {
                        breadcrumb: "Deposit",
                    },
                },
                {
                    path: ":id",
                    name: "Detail Deposit",
                    component: () => import("../views/vms/onExchange/deposit/DetailDeposit.vue"),
                    meta: {
                        breadcrumb: "Detail Deposit",
                    },
                },
            ],
        },
        {
            path: "withdrawal",
            component: () => import("../views/vms/onExchange/withdrawal/LayoutWithdrawal.vue"),
            meta: {
                breadcrumb: "Withdrawal",
            },
            children: [
                {
                    path: "",
                    name: "Withdrawal",
                    component: () => import("../views/vms/onExchange/withdrawal/Withdrawal.vue"),
                    meta: {
                        breadcrumb: "Withdrawal",
                    },
                },
                {
                    path: ":id",
                    name: "Detail Withdrawal",
                    component: () => import("../views/vms/onExchange/withdrawal/DetailWithdrawal.vue"),
                    meta: {
                        breadcrumb: "Detail Withdrawal",
                    },
                },
            ],
        },
        {
            path: "inventory",
            component: () => import("../views/vms/onExchange/inventory/LayoutInventiry.vue"),
            meta: {
                breadcrumb: "Inventory",
            },
            children: [
                {
                    path: "",
                    component: () => import("../views/vms/onExchange/inventory/Inventory.vue"),
                    name: "Inventory",
                    meta: {
                        breadcrumb: "Inventory",
                    },
                },

                {
                    path: ":id",
                    name: "Detail Inventory",
                    component: DetailVMinventory,
                    meta: {
                        breadcrumb: "Detail Inventory",
                    },
                },
            ],
        },
    ],
};
